import { render, staticRenderFns } from "./facture.vue?vue&type=template&id=033b6f48&"
import script from "./facture.vue?vue&type=script&lang=js&"
export * from "./facture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports